import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { MeetingBookingService } from 'src/app/private/services/meeting-booking.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import {
  getBookingIdFromMeeting,
  isPartEBookingMeeting,
} from 'src/app/utils/meeting-booking.util';

@Component({
  selector: 'app-lead-metting',
  templateUrl: './lead-metting.component.html',
  styleUrls: ['./lead-metting.component.scss']
})
export class LeadMettingComponent {

  
    btnLoading = false;
    deleteLoading = false;
    mettingList: any[] = [];
    loading = false;
    @Output() close = new EventEmitter<void>();
    @Input() editFieldValues: any;
  
    editNoteData: any;
  
    constructor(
      private toaster: ToastrService,
      private api: LeadService,
      private meetingBookingService: MeetingBookingService,
      private localstorage: LocalStorageService,
      private modalService: NgbModal,
      private tracker: TrackingService
    ) {}
  
    openModal(content: any) {
      this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
    }
  
    closeModal() {
      this.close.emit();
    }
  
    ngOnInit() {
      this.getAllMettings();
    }
  
    getAllMettings() {
      this.loading = true;
  
      this.meetingBookingService
        .getAllMeetingDetails({
          client_id: this.localstorage.getClientId(),
          lead_id: this.editFieldValues.lead_id,
        })
        .subscribe({
        next: (res) => {
          this.mettingList = res || [];
          this.loading = false;
            // ✅ TRACK: Viewing lead meetings
        const desc = `Viewed all meetings for lead ID: ${this.editFieldValues.lead_id}`;
        this.tracker.track('View', 'Lead Meeting', desc);
        },
        error: (err) => {
          this.toaster.error(err.error.message || 'Something went wrong');
          this.loading = false;
        }
      });
    }
  
    reloadTable() {
      this.getAllMettings();
    }
  
    openModalEdit(content: any, data: any) {
      this.editNoteData = data;
      this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
       const desc = `Opened edit modal for meeting ID: ${data?.id}`;
    this.tracker.track('Open Modal', 'Edit Lead Meeting', desc);
    }
  
    openModalDelete(content: any, data: any) {
      this.editNoteData = data;
      this.modalService.open(content, { size: 'md', scrollable: true, centered: true });
       const desc = `Opened delete modal for meeting ID: ${data?.id}`;
    this.tracker.track('Open Modal', 'Delete Lead Meeting', desc);
    }
  
    getMeetingId(target: any): string {
      if (!target) {
        return '';
      }
      let details = target.google_meet_details;
      if (typeof details === 'string') {
        try {
          details = JSON.parse(details);
        } catch (e) {
          details = null;
        }
      }
      return details?.meeting_id || target.meeting_id || '';
    }

    handleDeleteNote(modal:any) {
      this.deleteLoading = true;

      if (isPartEBookingMeeting(this.editNoteData)) {
        this.cancelBookingMeeting(modal);
        return;
      }

      const payload = {
        "meeting_id": this.getMeetingId(this.editNoteData),
        "id": this.editNoteData.id,
        "client_id": this.localstorage.getClientId(),
        "user_id": this.localstorage.getUserId()
      }
  
      this.api.deleteAppointment(payload).subscribe({
        next: (res) => {
          this.toaster.success(res.message);
          this.deleteLoading = false;
          this.reloadTable();
          modal.dismiss('Cross click')
            // ✅ TRACK: Meeting deletion
        const desc = `Deleted meeting with ID: ${payload.id} (Google ID: ${payload.meeting_id}) for lead ID: ${this.editFieldValues.lead_id}`;
        this.tracker.track('Delete', 'Lead Meeting', desc);
        },
        error: (err) => {
          this.toaster.error(err.error.message || 'Something went wrong');
          this.deleteLoading = false;
        }
      });
    }

    private cancelBookingMeeting(modal: any): void {
      const bookingId = getBookingIdFromMeeting(this.editNoteData);
      if (!bookingId) {
        this.toaster.error('This meeting cannot be cancelled via the booking API. Missing booking reference.');
        this.deleteLoading = false;
        return;
      }

      this.meetingBookingService.cancelMeetingSlot({
        booking_id: bookingId,
        client_id: this.localstorage.getClientId(),
        reason: 'Cancelled from CRM',
      }).subscribe({
        next: (res) => {
          this.toaster.success(res?.message || 'Meeting cancelled successfully');
          this.deleteLoading = false;
          this.reloadTable();
          modal.dismiss('Cross click');
          const desc = `Cancelled Part E booking #${bookingId} for lead ID: ${this.editFieldValues.lead_id}`;
          this.tracker.track('Delete', 'Lead Meeting', desc);
        },
        error: (err) => {
          this.toaster.error(err?.error?.message || 'Something went wrong');
          this.deleteLoading = false;
        },
      });
    }
}
